import cx from 'classnames';
import { useBoolean, useScrollLock } from 'usehooks-ts';

import { UspBar } from './usp-bar';
import { PrimaryNavigation } from './primary-navigation';
import { SecondaryNavigation } from './secondary-navigation';
import { GlobalBannerContainer } from './global-banner/GlobalBannerContainer';
import { Category } from '@goed-platform/graphql/types';
import { MobileNavigation } from './mobile-navigation';

type NavigationProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigation: any;
    categoryNavigation: Category[];
};

export const Navigation = ({ navigation, categoryNavigation }: NavigationProps) => {
    const unmaskedData = navigation.goedBeNav;
    const { value: menuOpen, setTrue: showMenu, setFalse: hideMenu } = useBoolean(false);
    const { lock, unlock } = useScrollLock({ autoLock: false });

    const handleOpenMenu = () => {
        showMenu();
        lock();
    };

    const handleCloseMenu = () => {
        hideMenu();
        unlock();
    };

    return (
        <>
            {unmaskedData.globalBanners && unmaskedData.globalBanners.length > 0 && (
                <GlobalBannerContainer banners={unmaskedData.globalBanners} />
            )}
            {unmaskedData.uspBar && (
                <div className="nav__usps">
                    <UspBar {...unmaskedData.uspBar} />
                </div>
            )}
            <nav className={cx('nav__sticky')}>
                <PrimaryNavigation onClickMobileTrigger={handleOpenMenu} items={unmaskedData.uldNavigation} />
                <SecondaryNavigation categories={categoryNavigation} />
            </nav>
            <MobileNavigation visible={menuOpen} onClickClose={handleCloseMenu} items={unmaskedData.uldNavigation} />
        </>
    );
};
